import type { MiterSourceNode } from "./MiterSourceNode";

export class MiterSourceEdge {
  readonly a: MiterSourceNode;
  readonly b: MiterSourceNode;
  leftWidth: number;
  rightWidth: number;

  constructor(a: MiterSourceNode, b: MiterSourceNode, width: number) {
    this.a = a;
    this.b = b;
    this.leftWidth = width;
    this.rightWidth = width;
  }
}
